import { IcMandatory12 } from '@assets/icons/12x12';
import { IcInfo16 } from '@assets/icons/16x16';
import { IcInfo } from '@assets/icons/32x32';
import { HStack, Icon, Separator, Text, VStack } from '@chakra-ui/react';
import { ScrollArea } from '@components/ui/ScrollArea';
import { Tooltip } from '@components/ui/tooltip';
import { PropsWithChildren, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface CockpitFormLayoutProps extends PropsWithChildren {
  title: string;
  tooltipLabel?: string;
  width?: string | number;
  subTitle?: string;
  fullWidth?: boolean;
  showSeparator?: boolean;
  footer?: ReactNode;
}

export function CockpitFormSeparator({ width = '100%' }: Readonly<{ width?: string | number }>) {
  return <Separator size="md" borderColor="neutral.800" width={width} />;
}

export function CockpitFormLayout({
  title,
  children,
  tooltipLabel,
  width = '478px',
  fullWidth = false,
  showSeparator = true,
  subTitle,
  footer,
}: Readonly<CockpitFormLayoutProps>) {
  return (
    <ScrollArea backgroundColor="neutral.700">
      <VStack width="100%" paddingY={8} gap={5} alignSelf="center" height="100%" paddingX={5}>
        <HStack width={width} position="relative" justifyContent="center">
          <VStack gap={1} maxWidth={width}>
            <Text textStyle="xl">
              <FormattedMessage id={title} />
            </Text>
            {subTitle && (
              <Text textStyle="md" color="neutral.300">
                <FormattedMessage id={subTitle} />
              </Text>
            )}
          </VStack>
          {tooltipLabel && (
            <Tooltip
              contentProps={{ maxWidth: 'fit-content', padding: 3 }}
              content={
                <HStack gap={3} width="max-content" alignItems="start">
                  <Icon as={IcInfo} boxSize="32px" color="neutral.300" />
                  <Text width="max-content" whiteSpace="pre-line" color="neutral.200">
                    {tooltipLabel}
                  </Text>
                </HStack>
              }
            >
              <Icon position="absolute" right={0} as={IcInfo16} color="neutral.300" boxSize="16px" />
            </Tooltip>
          )}
        </HStack>
        <HStack position="absolute" top={7} right={7} gap={1}>
          <Icon as={IcMandatory12} boxSize="12px" />
          <Text color="neutral.300">
            <FormattedMessage id="form.mandatory" />
          </Text>
        </HStack>
        {showSeparator && <CockpitFormSeparator width={fullWidth ? '100%' : width} />}
        <VStack width={fullWidth ? '100%' : width} height="100%" gap={5} paddingTop={0}>
          {children}
        </VStack>
        {footer}
      </VStack>
    </ScrollArea>
  );
}
